import React, { createContext, FC, JSX, PropsWithChildren, useContext, useMemo, useState } from "react";
import { PaymentsQueryProvider } from "@lookiero/payments-front";

interface PaymentsContextType {
  readonly showPaymentModalBusy: boolean;
  readonly setShowPaymentModalBusy: (value: boolean) => void;
}

const PaymentsContext = createContext<PaymentsContextType>(null as unknown as PaymentsContextType);

const PaymentsContextProvider: FC<PropsWithChildren> = ({ children }): JSX.Element => {
  const [showPaymentModalBusy, setShowPaymentModalBusy] = useState(false);

  const value = useMemo(
    () => ({
      showPaymentModalBusy,
      setShowPaymentModalBusy,
    }),
    [showPaymentModalBusy, setShowPaymentModalBusy],
  );

  return (
    <PaymentsContext.Provider value={value}>
      <PaymentsQueryProvider>{children}</PaymentsQueryProvider>
    </PaymentsContext.Provider>
  );
};

const usePaymentsContext = (): PaymentsContextType => useContext(PaymentsContext);

export { usePaymentsContext, PaymentsContextProvider };
